import { axiosConfig } from '../api/axios-config.js'

// 裝置
export const chiline = {
  // 取得清單
  get: (id, token) => axiosConfig.get(`/api/chiline/${id || ''}`, token),

  // 創建
  create: (data, token) => axiosConfig.post('/api/chiline', data, token),

  // 更新
  update: (id, data, token) => axiosConfig.patch(`/api/chiline/${id}`, data, token),

  // 刪除
  delete: (id, token) => axiosConfig.delete(`/api/chiline/${id}`, token)
}
